import React from "react"
import DatasetsList from "../components/DatasetsList"
import { Flex } from "@chakra-ui/react"

export default function DatasetListView() {
  return (
    <Flex direction="column" flexGrow={1} minHeight={0} width="100%">
      <DatasetsList />
    </Flex>
  )
}
